// language=GraphQL
export const ALL_AGE_GROUP_SERVICES_QUERY = `query Query($withAgeGroup: Boolean = false) {
  ageGroupServices: ratioAgeGroupServices {
    id
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    ratioServiceNo
  }
}`

// language=GraphQL
export const SINGLE_AGE_GROUP_SERVICE_QUERY = `query Query($id: ID!, $withAgeGroup: Boolean = false) {
  ageGroupService: ratioAgeGroupService(id: $id) {
    id
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    ratioServiceNo
  }
}`

// language=GraphQL
export const CREATE_AGE_GROUP_SERVICE_MUTATION = `
  mutation Mutation($input: CreateRatioAgeGroupServiceInput, $withAgeGroup: Boolean = false) {
    ageGroupService: createRatioAgeGroupService(input: $input) {
      id
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUP_SERVICE_MUTATION = `
  mutation Mutation($input: UpdateRatioAgeGroupServiceInput, $withAgeGroup: Boolean = false) {
    ageGroupService: updateRatioAgeGroupService(input: $input) {
      id
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUP_SERVICE_MUTATION = `
  mutation Mutation($input: DeleteRatioAgeGroupServiceInput) {
    deleteRatioAgeGroupService(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION = `
  mutation Mutation($input: DeleteRatioAgeGroupServiceInput) {
    forceDeleteRatioAgeGroupService(input: $input) {
      success
    }
  }`
// language=GraphQL
export const AGE_GROUP_SERVICES_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioCollectiveAddons: Boolean = false, $withRatioCollectiveDiscounts: Boolean = false) {
  groupedDependents: ratioAgeGroupServiceDependents(id: $id) {
    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {
      id
      label
      info
    }
    ratioCollectiveDiscounts @include(if: $withRatioCollectiveDiscounts) {
      id
      label
      info
    }
  }
}`
